// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"d0f1d3b8","839":"ed1a38c0"}[chunkId] + ".chunk.js";
};